<template>
  <div id="rightMenu">
    <button :disabled="!(isEditR_&&!sentenceShow_ &&inputTxt_)" @click="onCopy('剪切')">
      <i :class="!(isEditR_&&!sentenceShow_ &&inputTxt_) ? 'cut-but-dis' : 'cut-but'"></i>
      <span>剪切</span>
    </button>

    <button @click="onCopy('复制')">
      <i class="copy-but"></i>
      <span>复制</span>
    </button>
    <!-- <button @click="onCopy('粘贴', $event)" :disabled="!sentenceShow_"><i class="paste-but"></i>粘贴<em>Ctrl+V</em></button> -->

    <button :disabled="!sentenceShow_" @click="rigBoxShow(2)">
      <i :class="!sentenceShow_ ? 'find-but-dis' : 'find-but'"></i>
      <span>查词</span>
    </button>

    <!-- <button @click="rigClick('memory')" :disabled="!(isEditR_&&!sentenceShow_)"><i
            :class="!(isEditR_&&!sentenceShow_) ? 'term-but-dis':'term-but'"></i>添加记忆</button> -->
    <button @click="rigAddTerm('添加术语')" :disabled="!sentenceShow_">
      <i :class="!sentenceShow_ ? 'term-but-dis':'term-but'"></i>
      <span>添加术语</span>
    </button>
    <button v-if="!wordEditorTier" @click="mergeSentence"
            :disabled="(!(!isXlsx_ && sentenceShow_ &&isEditR_ )||(isXlsx2_))">
      <i :class="!(!isXlsx_ && sentenceShow_ &&isEditR_) ? 'merge-but-dis':'merge-but'"></i>
      <span>合并下一句</span>
    </button>

    <button v-if="!wordEditorTier" @click="splitSentence"
            :disabled="(!(!isXlsx_ && sentenceShow_ &&isEditR_ )||(isXlsx2_))">
      <i :class="!(!isXlsx_ && sentenceShow_ &&isEditR_)? 'split-but-dis':'split-but'"></i>
      <span>拆分句段</span>
    </button>

    <button @click="anewTranslate" v-if="typeShow_" :disabled="!(sentenceShow_ &&isEditR_)">
      <i :class="!(sentenceShow_ &&isEditR_)? 'new-but-dis':'new-but'"></i>
      <span>重新机翻</span>
    </button>

    <!-- <button :disabled="menuDisabled_" @click="addPostil()" v-if="typeShow_"><i
            :class="menuDisabled_?'postil-but-dis':'postil-but'"></i>添加批注</button> -->

    <button :disabled="!(sentenceShow_ &&isEditR_)" v-if="typeShow_" @click="copySource()">
      <i :class="!(sentenceShow_ &&isEditR_)? 'paste-but-dis':'paste-but'"></i>
      <span>复制到译文</span>
    </button>

    <button @click="unlockSentence" :disabled="!isLock_">
      <i :class="isLock_? 'unlock-but':'unlock-but-dis'"></i>
      <span>解锁重复句段</span>
    </button>
  </div>
</template>

<script>

export default {
  props: ["sentenceShow", 'isEditR', "ifSubmit", "typeShow", "inputTxt", 'isXlsx', 'wordEditorTier', 'isLock', 'format'],
  name: "rightMenu",
  data () {
    return {}
  },
  computed: {
    sentenceShow_: function () { // true:原文 false：译文
      // console.log(this.sentenceShow);
      return this.sentenceShow;
    },
    ifSubmit_: function () {
      return this.ifSubmit;
    },
    typeShow_: function () {
      return this.typeShow;
    },
    inputTxt_: function () {
      return this.inputTxt;
    },
    isXlsx_: function () {
      return this.isXlsx;
    },

    isXlsx2_: function () {
      // console.log(this.format);
      return (((this.format).toLowerCase() === 'xls') || ((this.format).toLowerCase() === 'xlsx'));
    },

    isEditR_: function () {
      // console.log(this.isEditR);

      return this.isEditR;
    },
    isLock_: function () {
      // console.log(this.isLock);
      return this.isLock;
    }
  },
  methods: {
    // 右键操作
    onCopy (name) {
      switch (name) {
        case "剪切":
          document.execCommand("cut");
          break;
        case "复制":
          document.execCommand("copy", "false");
          break;
        case "粘贴":
          this.$message.closeAll();
          this.$message({
            message: "暂不支持鼠标右键粘贴，试试快捷键Ctrl+V吧",
            type: "error"
          });
          break;
        default:
          break;
      }
    },
    rigBoxShow (data) {
      this.$emit('rigBoxShow', data)
    },
    rigAddTerm () {
      this.$emit("rigAddTerm")
    },
    anewTranslate () {
      this.$emit("anewTranslate")
    },
    mergeSentence () {
      this.$emit("mergeSentence")
    },
    splitSentence () {
      this.$emit("splitSentence")
    },
    copySource () {
      this.$emit("copySource");
    },
    rigClick () {
      this.$emit('rigClick', 'memory')
    },
    unlockSentence () {
      this.$emit('unlockSentence')
    }
  },

  mounted () {
    // console.log(this.format)
  }

}
</script>
<style lang="less" scoped>
#rightMenu {
  list-style: none;
  width: 170px;
  // height:180px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  margin: 0px;
  padding: 10px;
  position: absolute;
  z-index: 4000;
  top: 0px;

  .bor {
    height: 1px;
    width: 100%;
    background: rgba(229, 229, 229, 1);
    margin: 5px 0px;
  }

  i {
    display: inline-block;
    height: 16px;
    width: 17px;
    margin-right: 5px;
    position: relative;
    top: 2px;
  }

  .cut-but {
    background: url("~@/assets/imgs/editor/sm_jq.png") no-repeat;
  }

  .copy-but {
    background: url("~@/assets/imgs/editor/sm_fz.png") no-repeat;
  }

  .paste-but {
    background: url("~@/assets/imgs/editor/sm_zt.png") no-repeat;
  }

  .find-but {
    background: url("~@/assets/imgs/editor/sm_cx.png") no-repeat;
  }

  .term-but {
    background: url("~@/assets/imgs/editor/sm_tj.png") no-repeat;
  }

  .postil-but {
    background: url("~@/assets/imgs/editor/sm_pz.png") no-repeat;
  }

  .paste-but-dis {
    background: url("~@/assets/imgs/editor/hs_sm_zt.png") no-repeat;
  }

  .cut-but-dis {
    background: url("~@/assets/imgs/editor/hs_sm_jq.png") no-repeat;
  }

  .copy-but-dis {
    background: url("~@/assets/imgs/editor/hs_sm_fz.png") no-repeat;
  }

  .find-but-dis {
    background: url("~@/assets/imgs/editor/hs_sm_cx.png") no-repeat;
  }

  .term-but-dis {
    background: url("~@/assets/imgs/editor/hs_sm_tj.png") no-repeat;
  }

  .postil-but-dis {
    background: url("~@/assets/imgs/editor/hs_sm_pz.png") no-repeat;
  }

  .split-but {
    background: url("~@/assets/imgs/editor/yj_hs_cf.png") no-repeat;
  }

  .split-but-dis {
    background: url("~@/assets/imgs/editor/hs_cf.png") no-repeat;
  }

  .merge-but {
    background: url("~@/assets/imgs/editor/yj_hs_hb.png") no-repeat;
  }

  .merge-but-dis {
    background: url("~@/assets/imgs/editor/yj_hb.png") no-repeat;
  }

  .new-but {
    background: url("~@/assets/imgs/editor/yj_hs_cxjf.png") no-repeat;
  }

  .new-but-dis {
    background: url("~@/assets/imgs/editor/yj_cxjf.png") no-repeat;
  }

  .unlock-but {
    background: url("~@/assets/imgs/editor/unlocking_press.png") no-repeat;
  }

  .unlock-but-dis {
    background: url("~@/assets/imgs/editor/unlocking_normal.png") no-repeat;
  }
}

#rightMenu button:hover {
  background: #e7e7e7;
}

#rightMenu button {
  text-align: left;
  padding: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border: 0px;
  margin: 2px 0px;
  outline: none; //消除默认点击蓝色边框效果
}
</style>